import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Server from "../Drawers/Server";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Paper from "@mui/material/Paper";
import { visuallyHidden } from "@mui/utils";
import { makeStyles } from "@mui/styles";
import IconButton from "@mui/material/IconButton";
import { useTheme } from "@mui/material/styles";
import LastPageIcon from "@mui/icons-material/LastPage";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import RefreshIcon from "@mui/icons-material/Refresh";
import Link from "@mui/material/Link";
import { BASE_URL } from "../services/client/rest";
import EditIcon from "@mui/icons-material/Edit";
import ResetHostPool from "../Drawers/ResetHostPool";
import axios from "axios";
import ServerInfoApi from "../services/API/ServerInfo.Api";
import SearchIcon from "@mui/icons-material/Search";
import { useQuery } from "react-query";
import {
  Card,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  Input,
  InputAdornment,
  InputBase,
  TextField,
  Skeleton,
} from "@mui/material";
import { isEmpty } from "lodash";
import hu from "date-fns/esm/locale/hu/index.js";

function descendingComparator(a: any, b: any, orderBy: any) {
  var x = a[orderBy];
  var y = b[orderBy];
  if (orderBy == "cpu") {
    let _x = parseInt(x.replace("%", ""));
    if (isNaN(_x)) {
      _x = 0;
    }
    let _y = parseInt(y.replace("%", ""));
    if (isNaN(_y)) {
      _y = 0;
    }
    //  x=_x;
    //  y=_y;
    if (_y < _x) {
      return -1;
    }
    if (_y > _x) {
      return 1;
    }
    return 0;
  }
  if (y < x) {
    return -1;
  }
  if (y > x) {
    return 1;
  }
  return 0;
}

function getComparator(order: any, orderBy: any) {
  return order === "desc"
    ? (a: any, b: any) => descendingComparator(a, b, orderBy)
    : (a: any, b: any) => -descendingComparator(a, b, orderBy);
}

function stableSort(array: any, comparator: any) {
  const stabilizedThis = array.map((el: any, index: any) => [el, index]);
  stabilizedThis.sort((a: any, b: any) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el: any) => el[0]);
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
  },
  success: { backgroundColor: "green", color: "white !important" },
  alertHigh: { backgroundColor: "#E74C3C", color: "white !important" },
  alertMedium: { backgroundColor: "orange", color: "white !important" },
  hideCell: {
    display: "none !important",
  },
  myLink: {
    color: "gray",
    cursor: "pointer",
    marginLeft: "10px",
    "&:hover": { color: "green !important" },
  },
}));

export default function ServerInfo({ queryType }: { queryType: number }) {
  const classes = useStyles();
  const [order, setOrder] = React.useState<string>("desc");
  const [orderBy, setOrderBy] = React.useState("cpu");
  const [selected, setSelected] = React.useState([] as any);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(true);
  const [rowsPerPage, setRowsPerPage] = React.useState(20);
  const [dataIdealDBServers, SetDataIdealDBServers] = React.useState([] as any);
  const [dataIdealWvdServers, SetDataIdealWvdServers] = React.useState(
    [] as any
  );
  const [dataInfinityDBServers, SetDataInfinityDBServers] = React.useState(
    [] as any
  );
  const [dataInfinityWvdServers, SetDataInfinityWvdServers] = React.useState(
    [] as any
  );
  const [dataInformation, SetDataInformation] = React.useState([] as any);
  const [currentRow, SetCurrentRow] = React.useState([] as any);
  const [showServer, SetShowServer] = React.useState(false);
  const [showServerHost, SetShowServerHost] = React.useState(false);
  const [currentHostRow, SetCurrentHostRow] = React.useState([] as any);
  const [serverType, setServerType] = React.useState("All" as string);
  const [searchdata, SetSearchdata] = useState("" as string);
  const [filterData, setfilterData] = useState([] as any);

  var bearer = "Bearer " + localStorage.getItem("token");
  const headers = {
    Authorization: bearer,
  };

  function CloseServerDrawer(value: number = 0) {
    SetShowServer(value == 0 ? false : true);
  }

  function CloseServerHostDrawer(value: number = 0) {
    SetShowServerHost(value == 0 ? false : true);
  }

  const useStyles1 = makeStyles((theme: any) => ({
    root: {
      flexShrink: 0,
    },
  }));

  const headCells = [
    { id: "server", numeric: false, disablePadding: false, label: "Server" },
    { id: "cpu", numeric: true, disablePadding: false, label: "CPU(%)" },
    {
      id: "memory",
      numeric: false,
      disablePadding: false,
      label: "Memory Usage(%)",
    },
    {
      id: "availableDiskSpace",
      numeric: false,
      disablePadding: false,
      label: "AvailableDiskSpace",
    },
    {
      id: "lastUpdate",
      numeric: false,
      disablePadding: false,
      label: "LastUpdate",
    },
    {
      id: "activeUsers",
      numeric: true,
      disablePadding: false,
      label: "ActiveUsers",
    },
    {
      id: "maxActiveUsers",
      numeric: true,
      disablePadding: false,
      label: "MaxActiveUsers",
    },
    {
      id: "status",
      numeric: false,
      disablePadding: false,
      label: "Status",
    },
  ];

  function EnhancedTableHead(props: any) {
    const {
      onSelectAllClick,
      order,
      orderBy,
      numSelected,
      rowCount,
      onRequestSort,
    } = props;
    const createSortHandler = (property: any) => (event: any) => {
      onRequestSort(event, property);
    };

    return (
      <TableHead>
        <TableRow>
          {headCells.map((headCell) => (
            <TableCell
              style={{ backgroundColor: "#F2F3F4" }}
              key={headCell.id}
              align={headCell.numeric ? "right" : "left"}
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </Box>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }

  EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(["asc", "desc"]).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
  };
  function TablePaginationActions(props: any) {
    const classes = useStyles1();
    const theme: any = useTheme();
    const { count, page, rowsPerPage, onChangePage } = props;

    const handleFirstPageButtonClick = (event: any) => {
      setPage(0);
    };

    const handleBackButtonClick = (event: any) => {
      setPage(page - 1);
    };

    const handleNextButtonClick = (event: any) => {
      setPage(page + 1);
    };

    const handleLastPageButtonClick = (event: any) => {
      setPage(Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
      <div className={classes.root}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRightIcon />
          ) : (
            <KeyboardArrowLeftIcon />
          )}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeftIcon />
          ) : (
            <KeyboardArrowRightIcon />
          )}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </div>
    );
  }

  TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
  };

  useEffect(() => {
    GetIdealDBServers();
    GetIdealWvdServers();
    GetInfinityDBServers();
    GetInfinityWvdServers();
    GetInformation();
  }, [queryType]);

  function SaveChanges(rowHost: any) {
    SetShowServerHost(false);

    const request = {
      id: 0,
      type: "",
      server: rowHost.serverName,
      acknowledge: false,
      techRepresentative: "",
    };

    let url = BASE_URL + "ServerInfo/ResetHostPool";

    axios
      .post(url, request, {
        headers,
      })
      .then((response: any) => {})
      .catch((err: any) => {
        console.log(err);
      });
  }

  //!---------------------- useQuery for Live Data-Fetching ----------------------//
  const { data, refetch, isFetched, isFetching } = useQuery(
    ["GetServerInfoData"],
    () => ServerInfoApi.getServerInfoData(),
    {
      initialData: [],
      refetchInterval: 1000 * 60 * 1,
      refetchIntervalInBackground: true,
      refetchOnWindowFocus: false,
    }
  );

  useEffect(() => {
    setfilterData([...data]);
  }, [data]);

  function GetIdealDBServers() {
    let url = BASE_URL + "ServerInfo/IdealDBServers";

    fetch(url, {
      method: "get",
      headers: new Headers({
        Authorization: bearer,
      }),
    })
      .then((response) => response.json())
      .then((data) => SetDataIdealDBServers(data.data))
      .catch
      //error => alert('Error: ' + error)
      ();
  }
  function GetIdealWvdServers() {
    let url = BASE_URL + "ServerInfo/IdealWvdServers";

    fetch(url, {
      method: "get",
      headers: new Headers({
        Authorization: bearer,
      }),
    })
      .then((response) => response.json())
      .then((data) => SetDataIdealWvdServers(data.data))
      .catch
      //error => alert('Error: ' + error)
      ();
  }
  function GetInfinityDBServers() {
    let url = BASE_URL + "ServerInfo/InfinityDBServers";

    fetch(url, {
      method: "get",
      headers: new Headers({
        Authorization: bearer,
      }),
    })
      .then((response) => response.json())
      .then((data) => SetDataInfinityDBServers(data.data))
      .catch
      //error => alert('Error: ' + error)
      ();
  }
  function GetInfinityWvdServers() {
    let url = BASE_URL + "ServerInfo/InfinityWvdServers";

    fetch(url, {
      method: "get",
      headers: new Headers({
        Authorization: bearer,
      }),
    })
      .then((response) => response.json())
      .then((data) => SetDataInfinityWvdServers(data.data))
      .catch
      //error => alert('Error: ' + error)
      ();
  }
  function GetInformation() {
    let url = BASE_URL + "ServerInfo/Information";

    fetch(url, {
      method: "get",
      headers: new Headers({
        Authorization: bearer,
      }),
    })
      .then((response) => response.json())
      .then((data) => SetDataInformation(data.data))
      .catch
      //error => alert('Error: ' + error)
      ();
  }
  const handleRequestSort = (event: any, property: any) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event: any) => {};

  const handleRowClick = (currentRow: any) => {
    SetCurrentRow(currentRow);
    SetShowServer(true);
  };

  const HostPoolClick = (row: any) => {
    SetCurrentHostRow(row);
    SetShowServerHost(true);
  };

  const handleClick = (event: any, name: any) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected: any = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event: any, newPage: any) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event: any) => {
    setDense(event.target.checked);
  };

  const isSelected = (name: any) => selected.indexOf(name) !== -1;

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - GetData().length) : 0;

  function GetData() {
    return filterData.filter(filterRow);
  }

  function filterRow(element: any, index: any, array: any) {
    if (filterData.length > 0) {
      var obj1 = filterData[0];
      var keys = Object.keys(obj1);
      let i = 0;
      for (i = 0; i < keys.length; i++) {
        let cellValue = String(element[keys[i]]);
        if (cellValue.toLowerCase().includes(searchdata.toLowerCase())) {
          return true;
        }
      }
    }
    return false;
  }

  function CurrentDateTime() {
    return new Date().toLocaleString();
  }

  const selectHandler = (e: any) => {
    setServerType(e.target.value);
    if (e.target.value === "All") {
      setfilterData([...data]);
    } else {
      const fData = data.filter((ele: any) => ele.type === e.target.value);
      setfilterData([...fData]);
    }
  };

  //!---------- Server Info Table ----------//
  return (
    <>
      <Box>
        {/********** Filters Sub-header Start **********/}
        <Card
          sx={{
            padding: "15px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography color="text.secondary">Search Filters</Typography>

          <FormControl sx={{ minWidth: 250, marginLeft: "20px" }}>
            <InputLabel>Select Type</InputLabel>
            <Select
              name="serverType"
              value={serverType}
              label="Select Type"
              onChange={selectHandler}
            >
              <MenuItem value={"All"}>All</MenuItem>
              <MenuItem value={"IdealApp"}>Ideal Database Server</MenuItem>
              <MenuItem value={"InfinityApp"}>
                Infinity Database Server
              </MenuItem>
              <MenuItem value={"IdealPool"}>Ideal WVD Server</MenuItem>
              <MenuItem value={"InfinityPool"}>Infinity WVD Server</MenuItem>
            </Select>
          </FormControl>

          <Input
            onChange={(e) => SetSearchdata(e.target.value)}
            style={{
              border: "1px solid silver",
              borderRadius: "5px",
              padding: "0px 10px",
              width: "250px",
              height: "55px",
              marginLeft: "20px",
            }}
            placeholder="Search..."
            startAdornment={
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            }
          />
        </Card>
      </Box>
      {/********** Filters Sub-header End **********/}

      <Box display="flex" justifyContent="center" alignItems="center">
        <Box sx={{ width: "auto", display: "table" }}>
          {isFetching ? (
            <Box sx={{ width: 1080, marginTop: "12px" }}>
              <Skeleton animation="wave" height={40} />
              <Skeleton animation="wave" height={40} />
              <Skeleton animation="wave" height={40} />
              <Skeleton animation="wave" height={40} />
              <Skeleton animation="wave" height={40} />
              <Skeleton animation="wave" height={40} />
              <Skeleton animation="wave" height={40} />
              <Skeleton animation="wave" height={40} />
              <Skeleton animation="wave" height={40} />
              <Skeleton animation="wave" height={40} />
            </Box>
          ) : (
            <Paper
              sx={{
                width: "auto",
                mb: 2,
                margin: "10px 10px",
                border: "1px solid #E5E7E9",
              }}
            >
              <TableContainer>
                <Table
                  sx={{ minWidth: 750 }}
                  aria-labelledby="tableTitle"
                  size={dense ? "small" : "medium"}
                >
                  <EnhancedTableHead
                    numSelected={selected.length}
                    order={order}
                    orderBy={orderBy}
                    onSelectAllClick={handleSelectAllClick}
                    onRequestSort={handleRequestSort}
                    rowCount={GetData().length}
                  />
                  <TableBody>
                    {isFetched &&
                      stableSort(GetData(), getComparator(order, orderBy))
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row: any, index: any) => {
                          let colorClass = "";

                          if (row.status === "Unavailable")
                            colorClass = classes.alertHigh;
                          if (row.status === "Drain Mode")
                            colorClass = classes.alertHigh;
                          let classAlert = "";
                          if (parseInt(row.cpu.replace("%", "")) >= 50)
                            classAlert = classes.alertMedium;
                          if (parseInt(row.cpu.replace("%", "")) >= 75)
                            classAlert = classes.alertHigh;
                          const isItemSelected =
                            row.id == currentRow.id ? true : false;
                          let lastUpdate = row.lastUpdate.toString();
                          lastUpdate = new Date(
                            row.lastUpdate.toString().replace("T", " ") + " UTC"
                          )
                            .toLocaleString()
                            .replace(",", "");
                          let diskAlert = "";
                          if (row.alertCause === "Low Disk Space.")
                            diskAlert = classes.alertHigh;
                          let memoryAlert = "";
                          if (row.alertCause === "Low RAM Space")
                            memoryAlert = classes.alertHigh;
                          if(row.alertCause === "Sql Service is Down")
                            colorClass = classes.alertHigh;
                          return (
                            <TableRow
                              hover
                              role="checkbox"
                              key={row.id}
                              onClick={(event) => handleRowClick(row)}
                              selected={isItemSelected}
                            >
                              <TableCell>{row.server}</TableCell>
                              <TableCell align="right" className={classAlert}>
                                {row.cpu}
                              </TableCell>
                              <TableCell className={memoryAlert}>
                                {row.memory}
                              </TableCell>
                              <TableCell className={diskAlert}>
                                {row.availableDiskSpace}
                              </TableCell>
                              <TableCell>{lastUpdate}</TableCell>
                              <TableCell align="right">
                                {row.activeUsers}
                              </TableCell>
                              <TableCell align="right">
                                {row.maxActiveUsers}
                              </TableCell>
                              <TableCell align="center" className={colorClass}>
                                {row.alertCause === "Sql Service is Down"? "Sql Service is Down" : row.status}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                    {emptyRows > 0 && (
                      <TableRow
                        style={{
                          height: (dense ? 33 : 53) * emptyRows,
                        }}
                      >
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <table cellPadding={0} cellSpacing={0} style={{ width: "100%" }}>
                <tr>
                  <td>
                    <div
                      style={{
                        marginLeft: "15px",
                        font: "inherit",
                        fontFamily: "inherit",
                        fontSize: "small",
                        whiteSpace: "nowrap",
                      }}
                    >
                      As of {CurrentDateTime()}
                    </div>
                  </td>
                  <td>
                    <RefreshIcon
                      className={classes.myLink}
                      onClick={() => refetch()}
                    ></RefreshIcon>
                  </td>
                  <td style={{ width: "100%" }}>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 20, 25, 50, 100]}
                      component="div"
                      count={GetData().length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      ActionsComponent={TablePaginationActions}
                    />
                  </td>
                </tr>
              </table>
            </Paper>
          )}

          <Server
            open={showServer}
            rowServer={currentRow}
            onClose={CloseServerDrawer}
          />

          <Box>
            <Box style={{ display: "table" }}>
              {/* <h3>Ideal DB Servers</h3> */}
              <fieldset
                style={{
                  fontSize: "medium",
                  fontWeight: "bold",
                  border: "1px solid silver",
                }}
              >
                <legend>&nbsp;Ideal DB Servers&nbsp;</legend>

                <Table className={"myTable"}>
                  <TableHead>
                    <TableRow>
                      <TableCell>ServerName</TableCell>
                      <TableCell>PublicIP</TableCell>
                      <TableCell>DNS</TableCell>
                      <TableCell>NumDealers</TableCell>
                      <TableCell>NumUsers</TableCell>
                    </TableRow>
                  </TableHead>
                  {dataIdealDBServers.map((row: any, index: any) => {
                    // const total:any = total + row.numUsers;
                    return (
                      <TableRow hover role="checkbox">
                        <TableCell>{row.serverName}</TableCell>
                        <TableCell>{row.publicIP}</TableCell>
                        <TableCell>{row.dns}</TableCell>
                        <TableCell>{row.numDealers}</TableCell>
                        <TableCell>{row.numUsers}</TableCell>
                      </TableRow>
                    );
                  })}
                  <TableRow>
                    <TableCell colSpan={3}></TableCell>
                    <TableCell style={{ fontWeight: "bold" }}>
                      {dataIdealDBServers.reduce(
                        (total: number, row: any) =>
                          (total = total + row.numDealers),
                        0
                      )}
                    </TableCell>
                    <TableCell style={{ fontWeight: "bold" }}>
                      {dataIdealDBServers.reduce(
                        (total: number, row: any) =>
                          (total = total + row.numUsers),
                        0
                      )}
                    </TableCell>
                  </TableRow>
                </Table>
              </fieldset>
            </Box>
          </Box>

          <Box>
            <Box style={{ display: "table" }}>
              {/* <h3>Ideal WVD Servers</h3> */}
              <fieldset
                style={{
                  fontSize: "medium",
                  fontWeight: "bold",
                  border: "1px solid silver",
                }}
              >
                <legend>&nbsp;Ideal WVD Servers&nbsp;</legend>

                <Table className={"myTable"}>
                  <TableHead>
                    <TableRow>
                      <TableCell>ServerName</TableCell>
                      <TableCell align="right">NumDealers</TableCell>
                      <TableCell align="right">NumUsers</TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableHead>
                  {dataIdealWvdServers.map((row: any, index: any) => {
                    return (
                      <TableRow hover role="checkbox">
                        <TableCell>{row.serverName}</TableCell>
                        <TableCell align="center">{row.numDealers}</TableCell>
                        <TableCell align="center">{row.numUsers}</TableCell>
                        <TableCell
                          style={{
                            color: "gray",
                            cursor: "pointer",
                            textDecoration: "underline",
                          }}
                          onClick={(event) => HostPoolClick(row)}
                        >
                          <EditIcon style={{ fontSize: "small" }}></EditIcon>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  <TableRow>
                    <TableCell colSpan={1}></TableCell>
                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                      {dataIdealWvdServers.reduce(
                        (total: number, row: any) =>
                          (total = total + row.numDealers),
                        0
                      )}
                    </TableCell>
                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                      {dataIdealWvdServers.reduce(
                        (total: number, row: any) =>
                          (total = total + row.numUsers),
                        0
                      )}
                    </TableCell>
                  </TableRow>
                </Table>
              </fieldset>
            </Box>
            <ResetHostPool
              open={showServerHost}
              rowHost={currentHostRow}
              SaveChanges={SaveChanges}
              onClose={CloseServerHostDrawer}
            />
          </Box>

          <Box>
            <Box style={{ display: "table" }}>
              {/* <h3>Infinity DB Servers</h3> */}
              <fieldset
                style={{
                  fontSize: "medium",
                  fontWeight: "bold",
                  border: "1px solid silver",
                }}
              >
                <legend>&nbsp;Infinity DB Servers&nbsp;</legend>

                <Table className={"myTable"}>
                  <TableHead>
                    <TableRow>
                      <TableCell>ServerName</TableCell>
                      <TableCell>PublicIP</TableCell>
                      <TableCell>DNS</TableCell>
                      <TableCell>NumDealers</TableCell>
                      <TableCell>NumUsers</TableCell>
                    </TableRow>
                  </TableHead>
                  {dataInfinityDBServers.map((row: any, index: any) => {
                    return (
                      <TableRow hover role="checkbox">
                        <TableCell>{row.serverName}</TableCell>
                        <TableCell>{row.publicIP}</TableCell>
                        <TableCell>{row.dns}</TableCell>
                        <TableCell>{row.numDealers}</TableCell>
                        <TableCell>{row.numUsers}</TableCell>
                      </TableRow>
                    );
                  })}
                  <TableRow>
                    <TableCell colSpan={3}></TableCell>
                    <TableCell style={{ fontWeight: "bold" }}>
                      {dataInfinityDBServers.reduce(
                        (total: number, row: any) =>
                          (total = total + row.numDealers),
                        0
                      )}
                    </TableCell>
                    <TableCell style={{ fontWeight: "bold" }}>
                      {dataInfinityDBServers.reduce(
                        (total: number, row: any) =>
                          (total = total + row.numUsers),
                        0
                      )}
                    </TableCell>
                  </TableRow>
                </Table>
              </fieldset>
            </Box>
          </Box>

          <Box>
            <Box style={{ display: "table" }}>
              {/* <h3>Infinity WVD Server</h3> */}
              <fieldset
                style={{
                  fontSize: "medium",
                  fontWeight: "bold",
                  border: "1px solid silver",
                }}
              >
                <legend>&nbsp;Infinity WVD Server&nbsp;</legend>

                <Table className={"myTable"}>
                  <TableHead>
                    <TableRow>
                      <TableCell>ServerName</TableCell>
                      <TableCell align="right">NumDealers</TableCell>
                      <TableCell align="right">NumUsers</TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableHead>
                  {dataInfinityWvdServers.map((row: any, index: any) => {
                    return (
                      <TableRow hover role="checkbox">
                        <TableCell>{row.serverName}</TableCell>
                        <TableCell align="center">{row.numDealers}</TableCell>
                        <TableCell align="center">{row.numUsers}</TableCell>
                        <TableCell
                          style={{
                            color: "gray",
                            cursor: "pointer",
                            textDecoration: "underline",
                          }}
                          onClick={(event) => HostPoolClick(row)}
                        >
                          <EditIcon style={{ fontSize: "small" }}></EditIcon>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  <TableRow>
                    <TableCell colSpan={1}></TableCell>
                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                      {dataInfinityWvdServers.reduce(
                        (total: number, row: any) =>
                          (total = total + row.numDealers),
                        0
                      )}
                    </TableCell>
                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                      {dataInfinityWvdServers.reduce(
                        (total: number, row: any) =>
                          (total = total + row.numUsers),
                        0
                      )}
                    </TableCell>
                  </TableRow>
                </Table>
              </fieldset>
            </Box>
            <ResetHostPool
              open={showServerHost}
              rowHost={currentHostRow}
              SaveChanges={SaveChanges}
              onClose={CloseServerHostDrawer}
            />
          </Box>

          <Box>
            <Box style={{ display: "table" }}>
              <fieldset
                style={{
                  fontSize: "medium",
                  fontWeight: "bold",
                  border: "1px solid silver",
                }}
              >
                <legend>&nbsp;Information&nbsp;</legend>

                <Table
                  sx={{ minWidth: 650 }}
                  aria-label="simple table"
                  className={"myTable"}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell>Description</TableCell>
                      <TableCell align="right">Info</TableCell>
                    </TableRow>
                  </TableHead>
                  {dataInformation.map((row: any, index: any) => {
                    return (
                      <TableRow
                        hover
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                        role="checkbox"
                      >
                        <TableCell>{row.description}</TableCell>
                        <TableCell>
                          <Link
                            href={row.info}
                            target="_blank"
                            underline="hover"
                          >
                            {row.info}
                          </Link>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </Table>
              </fieldset>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}
